import { Component, inject, OnInit } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { IndicatorTreeComponent } from '../indicator-tree/indicator-tree.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-indicators',
  standalone: true,
  imports: [SharedModule, SidebarModule, IndicatorTreeComponent],
  templateUrl: './indicators.component.html',
  styleUrl: './indicators.component.scss',
})
export class IndicatorsComponent implements OnInit {
  readonly activeUserStore = inject(ActiveUserStore);
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-6',
    icon: 'fas fa-folder-tree',
    headerText: 'Indikatorenverzeichnis',
    quickLinks: [
      {
        styleClass: 'mr-auto',
        label: 'Vorlagen',
        icon: 'fas fa-pen-ruler',
        severity: 'secondary',
        visible: this.activeUserStore.canAccessPool(),
        routerLink: [
          '/data-backend',
          {
            outlets: {
              overlay: ['vorlagen'],
            },
          },
        ],
      },
      {
        label: 'Indikator',
        icon: 'fas fa-plus-circle',
        severity: 'success',
        visible: this.activeUserStore.canAccessEntityAdder(),
        routerLink: [
          '/data-backend',
          {
            outlets: {
              overlay: [
                'neu',
                { outlets: { panel: ['indikator', 'neu', 'general'] } },
              ],
            },
          },
        ],
      },
      {
        label: 'Ordner',
        icon: 'fas fa-plus-circle',
        severity: 'success',
        visible: this.activeUserStore.canAccessEntityAdder(),
        routerLink: [
          '/data-backend',
          {
            outlets: {
              overlay: [
                'neu',
                { outlets: { panel: ['indikatoren-bereich', 'neu'] } },
              ],
            },
          },
        ],
      },
    ],
  };

  constructor(private sidebarService: SidebarService) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * It initializes the sidebar configuration by calling the sidebar service method with a delay.
   *
   * @return {void} Does not return any value.
   */
  ngOnInit(): void {
    setTimeout(() => {
      this.sidebarService.setConfiguration(this.sidebarConfig);
    }, 10);
  }
}
